import { GraphMode, ItemType } from '../../constants';
import { NodeModel, PasteCommandParams } from '../../types';
import { canAnyNodeBeCloned, executeBatch, getClonableNodes, guid, getGlobal } from '../../utils';
import { BaseCommand, baseCommand } from '../base';

export const PASTE_OFFSET_X = 10;
export const PASTE_OFFSET_Y = 10;

export const pasteCommand: BaseCommand<PasteCommandParams> = {
  ...baseCommand,

  params: {
    newIds: [],
    models: [],
  },

  canExecute(graph) {
    if (graph.getCurrentMode() === GraphMode.Readonly) return false;
    // Can be executed if at least one of the nodes can be cloned
    return canAnyNodeBeCloned(getGlobal(graph).clipboard.models);
  },

  init(graph) {
    const nodesToPaste = getClonableNodes(getGlobal(graph).clipboard.models) as NodeModel[];

    this.params = nodesToPaste.reduce(
      (acc: PasteCommandParams, model) => {
        const { x, y } = model;
        const id = guid();

        return {
          newIds: [...acc.newIds, id],
          models: [
            ...acc.models,
            {
              ...model,
              clonedNode: { ...model },
              id,
              x: (x || 0) + PASTE_OFFSET_X,
              y: (y || 0) + PASTE_OFFSET_Y,
            },
          ],
        };
      },
      {
        newIds: [],
        models: [],
      },
    );
  },

  execute(graph) {
    const models = getClonableNodes(this.params.models) as NodeModel[];

    executeBatch(graph, () => {
      models.forEach((model) => {
        graph.addItem(ItemType.Node, model);
      });
    });

    this.setSelectedItems(graph, this.params.newIds);
  },

  undo(graph) {
    const models = getClonableNodes(this.params.models) as NodeModel[];

    executeBatch(graph, () => {
      models.forEach((model) => {
        graph.removeItem(model.id);
      });
    });
  },

  shortcuts: [
    ['metaKey', 'v'],
    ['ctrlKey', 'v'],
  ],
};

export default pasteCommand;
